import { Component, EventEmitter, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';
import { ReferafriendComponent } from '../referafriend/referafriend.component';
import { NewslatterspopupComponent } from '../newslatterspopup/newslatterspopup.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})

export class FooterComponent  {
  constructor(public auth: AuthService, private modalService: NgbModal) {}

  @Output() showPrice: EventEmitter<boolean> = new EventEmitter();

  // Footer Refer a friend popup click event
  referafriend() {
    try {
      this.modalService.open(ReferafriendComponent, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
        size: 'xl'
      });
    } catch (error) {
      console.error('An error occurred in referafriend:', error);
    }
  }

  newslettersupdate() {
    try {
      this.modalService.open(NewslatterspopupComponent, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md'
      });
    } catch (error) {
      console.error('An error occurred in newslettersupdate:', error);
    }
  };
}
